import { render, staticRenderFns } from "./form22.vue?vue&type=template&id=11ba9c53&scoped=true"
import script from "./form22.vue?vue&type=script&lang=js"
export * from "./form22.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ba9c53",
  null
  
)

export default component.exports